var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart",
    },
    [
      _c("section", [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$gettext("Art der Wiederholung")) + "\n            "
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.repetition_type_value,
                  expression: "repetition_type_value",
                },
              ],
              attrs: {
                name: _vm.name + "_type",
              },
              on: {
                change: function change($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.repetition_type_value = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c(
                "option",
                {
                  attrs: {
                    value: "SINGLE",
                  },
                  domProps: {
                    selected:
                      !_vm.repetition_type_value ||
                      _vm.repetition_type_value === "SINGLE",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Keine Wiederholung")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  attrs: {
                    value: "DAILY",
                  },
                  domProps: {
                    selected: _vm.repetition_type_value === "DAILY",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Tägliche Wiederholung")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  attrs: {
                    value: "WORKDAYS",
                  },
                  domProps: {
                    selected: _vm.repetition_type_value === "WORKDAYS",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Wiederholung an jedem Werktag")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  attrs: {
                    value: "WEEKLY",
                  },
                  domProps: {
                    selected: _vm.repetition_type_value === "WEEKLY",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Wöchentliche Wiederholung")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  attrs: {
                    value: "MONTHLY",
                  },
                  domProps: {
                    selected: _vm.repetition_type_value === "MONTHLY",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Monatliche Wiederholung")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  attrs: {
                    value: "YEARLY",
                  },
                  domProps: {
                    selected: _vm.repetition_type_value === "YEARLY",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$gettext("Jährliche Wiederholung")) +
                      "\n                "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.repetition_type_value === "DAILY"
        ? _c("section", [
            _c(
              "label",
              {
                staticClass: "studiprequired",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Abstand in Tagen")) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    staticClass: "asterisk",
                    attrs: {
                      title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("*")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_interval_value,
                      expression: "repetition_interval_value",
                    },
                  ],
                  attrs: {
                    type: "number",
                    min: "1",
                    required: "",
                    name: _vm.name + "_interval",
                  },
                  domProps: {
                    value: _vm.repetition_interval_value,
                  },
                  on: {
                    input: function input($event) {
                      if ($event.target.composing) return
                      _vm.repetition_interval_value = $event.target.value
                    },
                  },
                }),
              ]
            ),
          ])
        : _vm.repetition_type_value === "WEEKLY"
        ? _c("section", [
            _c(
              "label",
              {
                staticClass: "studiprequired",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Abstand in Wochen")) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    staticClass: "asterisk",
                    attrs: {
                      title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("*")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_interval_value,
                      expression: "repetition_interval_value",
                    },
                  ],
                  attrs: {
                    type: "number",
                    min: "1",
                    required: "",
                    name: _vm.name + "_interval",
                  },
                  domProps: {
                    value: _vm.repetition_interval_value,
                  },
                  on: {
                    input: function input($event) {
                      if ($event.target.composing) return
                      _vm.repetition_interval_value = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$gettext("Wiederholung an bestimmten Wochentagen"))
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "1",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("1"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Montag")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "2",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("2"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Dienstag")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "3",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("3"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Mittwoch")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "4",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("4"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Donnerstag")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "5",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("5"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Freitag")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "6",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("6"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Samstag")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "_dow[]",
                    value: "7",
                  },
                  domProps: {
                    checked: _vm.repetition_dow_value.includes("7"),
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Sonntag")) +
                    "\n            "
                ),
              ]),
            ]),
          ])
        : _vm.repetition_type_value === "YEARLY"
        ? _c("section", [
            _c(
              "label",
              {
                staticClass: "studiprequired",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Abstand in Jahren")) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    staticClass: "asterisk",
                    attrs: {
                      title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("*")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_interval_value,
                      expression: "repetition_interval_value",
                    },
                  ],
                  attrs: {
                    type: "number",
                    min: "1",
                    required: "",
                    name: "name + '_interval'",
                  },
                  domProps: {
                    value: _vm.repetition_interval_value,
                  },
                  on: {
                    input: function input($event) {
                      if ($event.target.composing) return
                      _vm.repetition_interval_value = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Art der jährlichen Wiederholung")) +
                  "\n            "
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_month_type_value,
                      expression: "repetition_month_type_value",
                    },
                  ],
                  attrs: {
                    name: _vm.name + "_month_type",
                  },
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.repetition_month_type_value = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "dom",
                      },
                      domProps: {
                        selected: _vm.repetition_month_type_value === "dom",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Wiederholung an einem bestimmten Datum"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "dow",
                      },
                      domProps: {
                        selected: _vm.repetition_month_type_value === "dow",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Wiederholung an einem bestimmten Wochentag"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.repetition_month_type_value === "dom"
              ? _c("label", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("Tag")) +
                      "\n            "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.repetition_dom_value,
                        expression: "repetition_dom_value",
                      },
                    ],
                    attrs: {
                      type: "number",
                      name: _vm.name + "_dom",
                      min: "1",
                      max: "31",
                    },
                    domProps: {
                      value: _vm.repetition_dom_value,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.repetition_dom_value = $event.target.value
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Monat")) +
                  "\n            "
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_month_value,
                      expression: "repetition_month_value",
                    },
                  ],
                  attrs: {
                    name: _vm.name + "_month",
                  },
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.repetition_month_value = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "1",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 1,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Januar")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "2",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 2,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Februar")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "3",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 3,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("März")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "4",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 4,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("April")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "5",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 5,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Mai")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "6",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 6,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Juni")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "7",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 7,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Juli")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "8",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 8,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("August")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "9",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 9,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("September")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "10",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 10,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Oktober")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "11",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 11,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("November")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "12",
                      },
                      domProps: {
                        selected: _vm.repetition_month_value === 12,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Dezember")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.repetition_type_value === "MONTHLY"
        ? _c("section", [
            _c(
              "label",
              {
                staticClass: "studiprequired",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Abstand in Monaten")) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    staticClass: "asterisk",
                    attrs: {
                      title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("*")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_interval_value,
                      expression: "repetition_interval_value",
                    },
                  ],
                  attrs: {
                    type: "number",
                    min: "1",
                    required: "",
                    name: _vm.name + "_interval",
                  },
                  domProps: {
                    value: _vm.repetition_interval_value,
                  },
                  on: {
                    input: function input($event) {
                      if ($event.target.composing) return
                      _vm.repetition_interval_value = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Art der monatlichen Wiederholung")) +
                  "\n            "
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_month_type_value,
                      expression: "repetition_month_type_value",
                    },
                  ],
                  attrs: {
                    name: _vm.name + "_month_type",
                  },
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.repetition_month_type_value = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "dom",
                      },
                      domProps: {
                        selected: _vm.repetition_month_type_value === "dom",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Wiederholung an einem bestimmten Tag des Monats"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "dow",
                      },
                      domProps: {
                        selected: _vm.repetition_month_type_value === "dow",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Wiederholung an einem bestimmten Wochentag"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.repetition_type_value === "MONTHLY" &&
      _vm.repetition_month_type_value === "dom"
        ? _c("section", [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$gettext(
                      "Wiederholung am einem bestimmten Tag des Monats"
                    )
                  ) +
                  "\n            "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.repetition_dom_value,
                    expression: "repetition_dom_value",
                  },
                ],
                attrs: {
                  type: "number",
                  min: "1",
                  name: _vm.name + "_dom",
                },
                domProps: {
                  value: _vm.repetition_dom_value,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) return
                    _vm.repetition_dom_value = $event.target.value
                  },
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      ["MONTHLY", "YEARLY"].includes(_vm.repetition_type_value) &&
      _vm.repetition_month_type_value === "dow"
        ? _c("section", [
            _c(
              "label",
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$gettext("Wiederholung an einem bestimmten Wochentag")
                    ) +
                    "\n            "
                ),
                _c("day-of-week-select", {
                  attrs: {
                    name: _vm.name + "_dow",
                    value: _vm.repetition_dow_value[0],
                    with_indeterminate: true,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$gettext(
                      "Wann im Monat soll die Wiederholung stattfinden?"
                    )
                  ) +
                  "\n            "
              ),
              _c(
                "select",
                {
                  attrs: {
                    name: _vm.name + "_dow_week",
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "",
                      },
                      domProps: {
                        selected: !_vm.repetition_dow_week_value,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Bitte wählen")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "1",
                      },
                      domProps: {
                        selected: _vm.repetition_dow_week_value === 1,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Am ersten gewählten Wochentag")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "2",
                      },
                      domProps: {
                        selected: _vm.repetition_dow_week_value === 2,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Am zweiten gewählten Wochentag")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "3",
                      },
                      domProps: {
                        selected: _vm.repetition_dow_week_value === 3,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Am dritten gewählten Wochentag")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "4",
                      },
                      domProps: {
                        selected: _vm.repetition_dow_week_value === 4,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Am vierten gewählten Wochentag")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "-1",
                      },
                      domProps: {
                        selected: _vm.repetition_dow_week_value === -1,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Am letzten gewählten Wochentag")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.repetition_type_value !== "SINGLE"
        ? _c("section", [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Ende der Wiederholung")) +
                  "\n            "
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.repetition_end_type_value,
                      expression: "repetition_end_type_value",
                    },
                  ],
                  attrs: {
                    name: _vm.name + "_rep_end_type",
                  },
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.repetition_end_type_value = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "",
                      },
                      domProps: {
                        selected: !_vm.repetition_end_type_value,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Nie")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "end_date",
                      },
                      domProps: {
                        selected: _vm.repetition_end_type_value === "end_date",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("An einem bestimmten Datum")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "end_count",
                      },
                      domProps: {
                        selected: _vm.repetition_end_type_value === "end_count",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext("Nach einer Anzahl von Terminen")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.repetition_end_type_value === "end_date"
        ? _c("section", [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Enddatum")) +
                  "\n            "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.repetition_end_date_value,
                    expression: "repetition_end_date_value",
                  },
                ],
                attrs: {
                  type: "text",
                  name: _vm.name + "_rep_end_date",
                  "data-date-picker": "",
                },
                domProps: {
                  value: _vm.repetition_end_date_value,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) return
                    _vm.repetition_end_date_value = $event.target.value
                  },
                },
              }),
            ]),
          ])
        : _vm.repetition_end_type_value === "end_count"
        ? _c("section", [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Anzahl der Termine")) +
                  "\n            "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.number_of_dates_value,
                    expression: "number_of_dates_value",
                  },
                ],
                attrs: {
                  type: "number",
                  min: "1",
                  name: _vm.name + "_number_of_dates",
                },
                domProps: {
                  value: _vm.number_of_dates_value,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) return
                    _vm.number_of_dates_value = $event.target.value
                  },
                },
              }),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }